// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"24":"non-react-concierge-ai-embed","209":"payment-confirmation","236":"reserve-online"}[chunkId] || chunkId) + "." + {"24":"84eea94e","96":"481ac36e","152":"5304f99c","209":"d94cdb34","236":"71935e2f"}[chunkId] + ".chunk.js";
};